
<button attr.aria-label="Navigate to {{ collection.name }} collection" class="collection-card" routerLink="{{ link }}">
  <img 
    aria-hidden="true" 
    *ngIf="pictureLocation; else genericLogoTemplate" 
    class="card__image" 
    src="{{ pictureLocation }}" 
    alt="{{ collection.name }} logo"
    [ngClass]="{'long': collection?.abvName === 'ncyte' || collection?.abvName === 'xpcyber' || collection?.abvName === 'deterlab' || collection?.abvName === '502_project' || collection?.abvName === 'cyberskills2work', 'small': collection?.abvName === 'clark4kids'}">
  <div aria-hidden="true" class="card__name" [ngClass]="{'long': collection?.abvName === 'deterlab' || collection?.abvName === 'cyberskills2work', 'small': collection?.abvName === 'clark4kids'}">{{ collection.name }}</div>
</button>

<ng-template #genericLogoTemplate>
  <clark-generic-collection-logo></clark-generic-collection-logo>
</ng-template>
